import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { DetailedQuote } from '../../../../domain/public-api';
import { HrefDirective } from '../../../../directives/href/href.directive';
import { LinkRegistryService } from '../../../../services/link-registry.service';
import { QuoteConstants, QuoteLinks } from '../quote.constants';

export interface QuoteLink extends QuoteLinks {
  url?: string;
}

export type QuoteLinkParams = Pick<DetailedQuote, 'issueType' | 'symbol' | 'country' | 'underlyingSymbol' | 'issueId'>;

@Component({
  selector: 'td-wb-quote-link',
  templateUrl: 'quote-link.component.html',
  styleUrls: ['quote-link.component.scss'],
  imports: [
    HrefDirective,
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteLinkComponent implements OnChanges {

  @Input() quote: QuoteLinkParams;

  links: Array<QuoteLink>;

  constructor(private linkRegistryService: LinkRegistryService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.quote !== undefined) {
      this.links = this.getLinks();
    }
  }

  private getLinks(): Array<QuoteLink> {
    let linksUrl = [];
    if (this.quote !== undefined && this.quote.issueType !== undefined) {
      linksUrl = QuoteConstants.getQuoteLinks(this.quote.issueType);
      for (const link of linksUrl) {
        link.url = this.getLinkUrl(link);
      }
    }
    return linksUrl;
  }

  private getLinkUrl(link: QuoteLink): string {
    let symbol = this.quote.symbol;
    if (this.quote[link.symbolFrom] !== undefined) {
      symbol = this.quote[link.symbolFrom];
    }
    if (link.symbolFrom === 'issueId') {
      return this.linkRegistryService.getLink(link.link) + (symbol === undefined ? '' : ('%2F' + symbol));
    }
    return this.linkRegistryService.getLink(link.link) +
      (this.quote.country === undefined ? '' : ('%2F' + this.quote.country)) + (symbol === undefined ? '' : ('%2F' + symbol));
  }
}
